import localforage from 'localforage'

class Offline {
    static async saveAction(data) {
        if ( !data || !data.type || (!data.id && !data.idFi && !data.bouteilles) ) {
            return true;
        }

        let verif = {
            'id': data.id,
            'type': data.type
        };

        let list = await Offline.getList();

        if (!_.find(list, verif)) {
            list.push(data);
            await localforage.setItem('offlineActions', JSON.stringify(list));
        }

        return true
    }

    static deleteAction(id, type) {
        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(list => {

                    if (!_.includes(id, 'N-') && !_.includes(id, 'F-') && !_.includes(id, 'P-')) {
                        id = parseInt(id)
                    }

                    _.remove(list, element => {
                        if(element.id === id && element.type === type){
                            return element
                        }
                    });

                    localforage
                        .setItem('offlineActions', JSON.stringify(list))
                        .then(res => resolve(res))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    static getList() {

        return new Promise((resolve, reject) => {

            localforage
                .getItem('offlineActions')
                .then(list => resolve(JSON.parse(list)))
                .catch(err => reject(err))

        })

    }

}

export default Offline



// WEBPACK FOOTER //
// ./src/js/models/Offline.js